export class EmailPartyBill {
    public FromDate!: string;
    public ToDate!: string;
    public PartyCode!: number;
}